<template>
  <a-card class="notice-page" title="">
    <a-tabs class="notice-tabs" v-model.trim="key" @change="callback">
      <a-tab-pane class="notice-tabs-pane" :key="''" :tab="$t('all')">
        <div v-if="noticeList.length > 0">
          <a-row class="notice-row" type="flex" v-for="(item,index) in noticeList" :key="index">
            <a-col class="notice-col" :span="16">
              <a-space>
                <a-icon class="notice-icon" type="sound" />
                <div style="margin-left: 24px;">
                  <dol-dict :option="item.MSG_TYPE" value-field="DIC_CODE" code="2013"/>
                  <div>{{ $dt(item, 'MSG_CONTENT')}}</div>
<!--                  <a :href="item.JUMP_URL"target="value">{{item.JUMP_URL}}</a>-->
                </div>
              </a-space>
            </a-col>
            <a-col :span="4">
              {{ $moment(item.CREATE_DATE).format('YYYY-MM-DD') }}
            </a-col>
            <a-col :span="4">
              <a-space>
                <a-button type="primary" @click="readNotice(item)" v-if="item.STATUS === 0">{{ $t('setToRead') }}</a-button>
<!--                <a-button @click="checkNotice(item)">{{ $t('view') }}</a-button>-->
              </a-space>
            </a-col>
          </a-row>
          <a-pagination show-quick-jumper class="notice-tabs-pagination" v-model.trim="current" :total="total" @change="onChange" />
        </div>
        <a-empty v-else />
      </a-tab-pane>
      <a-tab-pane v-for="item in noticeSortList" class="notice-tabs-pane" :key="item.DIC_CODE" :tab="$dt(item, 'DIC_NAME')">
        <div v-if="noticeList.length > 0">
          <a-row class="notice-row" type="flex" v-for="(item,index) in noticeList" :key="index">
            <template>
              <a-col class="notice-col" :span="16">
                <a-space>
                  <a-icon class="notice-icon" type="sound" />
                  <div style="margin-left: 24px;">
                    <dol-dict :option="item.MSG_TYPE" value-field="DIC_CODE" code="2013"/>
                    <div>{{ $dt(item, 'MSG_CONTENT')}}</div>
<!--                    <a :href="item.JUMP_URL"target="value">{{item.JUMP_URL}}</a>-->
                  </div>
                </a-space>
              </a-col>
              <a-col :span="4">
                {{ $moment(item.CREATE_DATE).format('YYYY-MM-DD') }}
              </a-col>
              <a-col :span="4">
                <a-space>
                  <a-button type="primary" @click="readNotice(item)" v-if="item.STATUS === 0">{{ $t('setToRead') }}</a-button>
                  <!--                <a-button>{{ $t('view') }}</a-button>-->
                </a-space>
              </a-col>
            </template>
          </a-row>
          <a-pagination show-quick-jumper class="notice-tabs-pagination" v-model.trim="current" :total="total" @change="onChange" />
        </div>
        <a-empty v-else />
      </a-tab-pane>
      <a @click="readAllNotice" slot="tabBarExtraContent">
        {{ $t('allRead') }}
      </a>
    </a-tabs>
  </a-card>
</template>

<script>
export default {
  name: "notice",
  data(){
    return {
      noticeList: [],
      noticeSortList: [],
      current:1,
      key:'',
      total: 0
    }
  },
  computed: {
    columns(){
      let columns = [];
      columns.push({ dataIndex: 'SHEET_AMT', title: '' , scopedSlots: { customRender: 'SHEET_AMT' } });
      columns.push({ dataIndex: 'SHOULD_AMT', title: '', scopedSlots: { customRender: 'SHEET_AMT' }  });
      columns.push({ dataIndex: 'ALREADY_AMT', title: '' , scopedSlots: { customRender: 'SHEET_AMT' } });
      columns.push({ dataIndex: '_id', width:'40px', scopedSlots: { customRender: 'operation' } });
      return columns;
    },
  },
  methods:{
    onChange(val) {
       this.current = val;
       this.getNoticeList()
    },
    checkNotice(data){
      switch (data.MSG_TYPE){
        case 20131001:
          this.$router.push(`/order/subscribe?MASTER_ID=${data.ORGI_CODE}`)
          break;
        default:
          break;
      }
    },
    readAllNotice(){
      let POST_CONTEXT = []
      this.noticeList.forEach(item =>{
        if(!item.STATUS){
          POST_CONTEXT.push({
            "MSG_ID": item.MSG_ID,
            "STATUS": 1
          })
        }
      })
      let POST_HEAD = [{
        "TABLE_NAME":"GT_REMIND_MESSAGE",
        "POST_METHOD": 2,
        "PRIMARY_KEY":"MSG_ID",
        "UPDATE_BY":this.$store.state.userInfo.USER_ID
      }];
      let condition = [{
        "POST_HEAD":POST_HEAD,
        "POST_CONTEXT":POST_CONTEXT
      }]
      this.$h5Api({
        type: '1002',
        data: condition,
        showMessage: true,
      }).then(({data}) =>{
        this.getNoticeList();
        this.$message.info(this.$t('operateSuccessfully'));
      })
    },
    readNotice(data){
      let condition = [
        {
          "POST_HEAD":[{
            "TABLE_NAME":"GT_REMIND_MESSAGE",
            "POST_METHOD": 2,
            "PRIMARY_KEY":"MSG_ID",
            "UPDATE_BY":this.$store.state.userInfo.USER_ID,
            "SYS_TYPE": 20011003
          }],
          "POST_CONTEXT": [{
            "MSG_ID": data.MSG_ID,
            "STATUS": 1
          }]
        }
      ]
      this.$h5Api({
        type: '1002',
        data: condition,
        showMessage: true,
      }).then(({data}) =>{
        this.getNoticeList();
        this.$message.info(this.$t('operateSuccessfully'));
      })
    },
    callback(key) {
      this.current = 1;
      this.key = key
      this.getNoticeList()
    },
    getNoticeList(){
      let data =  [{
        "MSG_CATE":this.key,
        "MSG_TYPE":'',
        "TARGET_BY":this.$store.state.userInfo.USER_ID,
        "PAGE_SIZE":10,
        "PAGE_INDEX":this.current,
        SYS_TYPE: 20011003
      }]
      this.$h5Api({
        type: '2031',
        data,
      }).then(data => {
        this.total = data.total
        this.noticeList = data.data?.GT_REMIND_MESSAGE;
      })
    },
    searchNoticeSort() {
      const data = [this.$dotNetUtil.commonQueryJson('GM_SYS_DIC',{DIC_TYPE: '2033'})];
      this.$h5Api({
        type: '1001',
        data,
      }).then(({data}) => {
        this.noticeSortList = data.DATA_LIST
      })
    }
  },
  created() {
    this.getNoticeList();
    this.searchNoticeSort();
  }
}
</script>

<style lang="scss">
  .notice-page{
    .notice-tabs{
      .notice-tabs-pane{
        .notice-row{
          align-items: center;padding: 24px 12px;
          .notice-col{
            .notice-icon{
              font-size: 20px;color: #016CBA;background: #E7EEF6;border-radius: 50%;padding: 10px;
            }
          }
        }
        .notice-tabs-pagination{
          display: flex;
          justify-content: flex-end;
        }
      }
    }
  }
</style>